import(/* webpackMode: "eager" */ "/workspace/app/(front)/policies-certificates/PoliciesAndCertificates.tsx")